<template>
  <div>
    <!-- 订单确认 -->
    <baseBreadcrumb
      :page="$t('message.orderConfirmation')"
      :menu="$t('message.orderForm')"
    />
    <orderMain status="21" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped>
</style>